import { useState, forwardRef, useEffect } from "react";
import Modal, { CommonModalProps } from "..";
import { CircularProgress, Stack } from "@mui/material";
import { titleService } from "../../../Core/Api/services";
import MovieCard, { MovieCardGrid } from "../../Cards/MovieCard/movie-card";
import { TitleType } from "../../../Core/Api/Types/title-type";
import { useTranslation } from "react-i18next";

export type ModalTmdbSearchElementProps = {
  name: string;
  type: TitleType;
  onSelect: (movie: any) => void;
};

export type ModalTmdbSearchProps = CommonModalProps<ModalTmdbSearchElementProps>;

const ModalTmdbSearch = forwardRef<any, ModalTmdbSearchProps>((props, ref) => {
  const { t } = useTranslation();
  const { closeModal, name, type, onSelect } = props;
  const [titles, setTitles] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    //call to get titles
    titleService.SearchTmdbMovies(name, type).then((response) => {
      if (response.tmdbTitles?.results && response.tmdbTitles?.results.length > 0) {
        setTitles(response.tmdbTitles?.results);
        setIsLoading(false);
      }
    });
  }, []);

  const handleSelectClick = (movie) => {
    onSelect && onSelect(movie);
    closeModal();
  };

  const handleCancelClick = () => {
    closeModal();
  };

  return (
    <Modal title={t("modal:title.chooseYourTitle")} reference={ref} closeModal={handleCancelClick} width={900}>
      <Stack spacing={2}>
        {isLoading && (
          <CircularProgress
            size={25}
            sx={{
              position: "absolute",
              top: 6,
              left: "50%",
              zIndex: 1,
            }}
          />
        )}

        {!isLoading && (
          <MovieCardGrid>
            {titles?.map((movie) => (
              <MovieCard
                index={movie.id}
                key={movie.id}
                selectedOnClick={true}
                onSelectClick={() => handleSelectClick(movie)}
                cover={movie.poster_path}
                expand={{ tagList: [], contentList: [], audioList: [], subtitleList: [], quality: "" }}
                labelList={[]}
                shareBtn={true}
                orderBtn={true}
                collectionBtn={true}
                noHover={true}
                obj={movie}
                {...movie}
              />
            ))}
          </MovieCardGrid>
        )}
      </Stack>
    </Modal>
  );
});

export default ModalTmdbSearch;
